import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import TourGrid from "../../components/tours/TourGrid";
import { getPackages } from "../../slice/khajurahoPackageSlice";
import heroImg from "../../Assets/img/1.jpg";
import { getMediaUrl } from "../../common/mediaUrl";

const WeekendTours = () => {
  const dispatch = useDispatch();
  const { data: packages, loading } = useSelector((state) => state.khajurahoPackage);

  useEffect(() => {
    dispatch(getPackages());
  }, [dispatch]);

  // Map backend data to the format expected by TourGrid/TourCard
    const mappedTours = packages.map(pkg => {
    let images = [];
    try {
      images = JSON.parse(pkg.multipleImages || "[]");
    } catch (e) {
      images = pkg.multipleImages ? pkg.multipleImages.split(',') : [];
    }

    return {
      id: pkg.id,
      title: pkg.name,
      tag: pkg.tag,
      duration: pkg.durationText,
      location: pkg.location,
      image: images.length > 0 ? getMediaUrl(images[0]) : null,
      description: pkg.description
    };
  });

  return (
    <section className="bg-[#fbf4e8] pb-24 min-h-screen">
      {/* Half Screen Hero Section */}
      <div className="relative h-[50vh] md:h-[60vh] w-full bg-black flex items-center justify-center overflow-hidden shadow-2xl rounded-b-[3rem] md:rounded-b-[4rem]">
        {/* Background Image & Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src={heroImg} 
            alt="Tour Packages" 
            className="w-full h-full object-cover opacity-60 scale-105 animate-[pulse_20s_ease-in-out_infinite]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/20"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/30 to-transparent"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center h-full pt-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white font-bold text-[10px] uppercase tracking-[0.2em] mb-4 shadow-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-main animate-pulse"></span>
              Premium Comfort
            </div>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-tight tracking-tight mb-4 drop-shadow-xl">
              Our 
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-main to-yellow-400">
                {" "}Tour Packages
              </span>
            </h1>
            <p className="text-sm md:text-base text-gray-300 font-medium max-w-lg leading-relaxed mb-8 border-l-2 border-orange-main pl-4">
              Explore the timeless beauty of Khajuraho and beyond with our curated weekend getaways.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Tour Grid Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-20">
        {loading ? (
           <div className="flex justify-center items-center py-20">
              <div className="w-12 h-12 border-4 border-orange-main border-t-transparent rounded-full animate-spin"></div>
           </div>
        ) : (
          <TourGrid tours={mappedTours} />
        )}
      </div>
    </section>
  );
};

export default WeekendTours;
